/**
 * Route definitions and constants
 *
 * This file contains route path definitions to avoid circular dependencies
 */

export enum ERoutesPathname {
  home = "/",
  showcase = "/showcase",
  patient = "/patient",
  registration = "/registration",
  queue = "/queue",
  patientDetail = "/patient/:id",
  patientConsultation = "/patient/consultation/:id",
  appointment = "/appointment",
  appointmentPreRegistration = "/appointment/pre-registration",
  login = "/login",
  signUp = "/sign-up",
  testPage = "/test-page",
  legacyArchive = "/legacy-archive",
  collaborativeDocument = "/collaborative-document",
  settings = "/settings",
  additionalInformation = "/additional-info",
  // Inventory
  inventory = "/inventory",
  inventoryCreate = "/inventory/create",
  inventoryDetail = "/inventory/:id",
  inventoryAdjustment = "/inventory/adjustment",
  inventoryAdjustmentCreate = "/inventory/adjustment/create",
  inventoryAdjustmentEdit = "/inventory/adjustment/edit/:id",
  inventoryAdjustmentDetail = "/inventory/adjustment/:id",
  suppliers = "/inventory/suppliers",
  suppliersCreate = "/inventory/suppliers/create",
  suppliersEdit = "/inventory/suppliers/edit/:id",
  suppliersDetail = "/inventory/suppliers/:id",
  erpIntegration = "/erp-integration",
  erpEdenConsumption = "/erp-integration/eden-consumption",
  erpItemMaster = "/erp-integration/item-master",
  // inventoryRequisition = "/inventory/requisition",
  // requisitionCreate = "/inventory/requisition/create",
  // requisitionEdit = "/inventory/requisition/edit/:id",
  // requisitionDetail = "/inventory/requisition/:id",
  delivery = "/inventory/delivery",
  deliveryCreate = "/inventory/delivery/create",
  deliveryEdit = "/inventory/delivery/:id",
  deliveryDetail = "/inventory/delivery/:id",
  dispensing = "/inventory/dispensing",
  dispensingCreate = "/inventory/dispensing/create",
  dispensingEdit = "/inventory/dispensing/edit/:id",
  dispensingFinalize = "/inventory/dispensing/finalize/:id",
  dispensingDetail = "/inventory/dispensing/:id",
  // Charge Code Management
  chargeCodeManagement = "/charge-code",
  chargeCodeCreate = "/charge-code/create",
  chargeCodeDetail = "/charge-code/:id",
  chargeCodeV2 = "/charge-code-v2",
  deliveryOrderV2 = "/charge-code-v2/delivery-orders",
  deliveryOrderV2Create = "/charge-code-v2/delivery-orders/create",
  deliveryOrderV2Edit = "/charge-code-v2/delivery-orders/edit/:id",
  deliveryOrderV2Detail = "/charge-code-v2/delivery-orders/:id",
  inventoryAdjustmentV2 = "/charge-code-v2/inventory-adjustments",
  inventoryAdjustmentV2Create = "/charge-code-v2/inventory-adjustments/create",
  inventoryAdjustmentV2Edit = "/charge-code-v2/inventory-adjustments/edit/:id",
  inventoryAdjustmentV2Detail = "/charge-code-v2/inventory-adjustments/:id",
  inventoryV2 = "/charge-code-v2/inventory",
  movementV2 = "/charge-code-v2/movements",
  // Investigations & Pharmacy
  investigations = "/investigations",
  // pharmacy = "/pharmacy",
  // pharmacyDetail = "/pharmacy/detail/:id",
  // pharmacyItem = "/pharmacy/:id",
  consultation = "/consultation/:id",
  medicalCoverage = "/medical-coverage/:id",
  // Invoice
  invoice = "/invoice",
  invoiceMedicalCoverage = "/invoice/medical-coverage",
  invoiceCorporateDetail = "/invoice/medical-coverage/corporate-invoice/:id",
  invoiceCreditNote = "/invoice/credit-note",
  invoiceCreditNoteDetail = "/invoice/credit-note/:id",
  // Services
  services = "/services",
  medicalServices = "/services/medical-services",
  medicalServicesCreate = "/services/medical-services/create",
  medicalServicesEdit = "/services/medical-services/:id",
  package = "/services/package",
  packageCreate = "/services/package/create",
  packageEdit = "/services/package/:id",
  packagesV2 = "/services/packagesV2",
  packagesV2Create = "/services/packagesV2/create",
  packagesV2Edit = "/services/packagesV2/:id",
  // Reports / Campaign / Task
  reports = "/reports",
  // campaign = "/campaign",
  // task = "/task",
  // Settings details
  medicalTemplate = "/settings/medical-template",
  medicalTemplateCreate = "/settings/medical-template/create",
  medicalTemplateEdit = "/settings/medical-template/edit/:id",
  dischargeAdvice = "/settings/discharge-advice",
  dischargeAdviceCreate = "/settings/discharge-advice/create",
  dischargeAdviceEdit = "/settings/discharge-advice/edit/:id",
  systemPreferences = "/settings/system-preferences",
  systemPreferencesCreate = "/settings/system-preferences/create",
  systemPreferencesEdit = "/settings/system-preferences/edit/:id",
  systemPreferencesDetail = "/settings/system-preferences/:id",
  // System Preferences - Vendor
  systemPreferencesVendorCreate = "/settings/system-preferences/vendor/create",
  systemPreferencesVendorEdit = "/settings/system-preferences/vendor/:id",
  systemPreferencesVendorDetail = "/settings/system-preferences/vendor/detail/:id",
  userManagement = "/settings/user-management",
  userManagementCreate = "/settings/user-management/create",
  userManagementEdit = "/settings/user-management/:id",
  roleManagement = "/settings/role-management",
  vendorManagement = "/settings/vendor-management",
  vendorCreate = "/settings/vendor-management/create",
  vendorEdit = "/settings/vendor-management/edit/:id",
  vendorDetail = "/settings/vendor-management/:id",
  notFound = "/404",
  // Printing
  printMedicationLabel = "/print/medication-label",
  printPatientLabel = "/print/patient-label",
  printMailingLabel = "/print/mailing-label",
  printLetterMC = "/print/letter-mc",
  printCorporateInvoice = "/print/corporate-invoice",
  printAdmissionForm = "/print/admission-form",
  printSOA = "/print/statement-of-account",
  printPaymentReceipt = "/print/payment-receipt",
  printCreditNote = "/print/credit-note",
  printItemizedInvoice = "/print/itemized-invoice",
  printUnitemizedInvoice = "/print/unitemized-invoice",
  printConsultNote = "/print/consult-note",
  printRadiologyOrders = "/print/radiology-orders",
  printRadiologyLabel = "/print/radiology-label",
  printRadiologyEOrderForm = "/print/radiology-e-order-form",
  // RAD & LAB
  radLabManagement = "/rad-lab",
}
